import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/solid/image-fill.svg'
import _imports_1 from '@/assets/icons/solid/video-fill.svg'


const _hoisted_1 = { class: "link" }
const _hoisted_2 = { class: "truncate inline-block space-x-1 text-sm w-full" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

import { // api
		getSceneOptionsRolesInstructionsByRecordId
	} from '../../../../queries'

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // vue
		ref,
		onMounted
	} from 'vue'

	import { // store
		localesStore
	} from '@/store/locales'

	
	const __default__ = { name: 'InstructionsList' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		data: {
			type: Object,
			default: () => {return {}}
		},
		showDetails: {
			type: Function, 
			default: () => {return}
		},
		previous: {
			type: Object, 
			default: () => {return {}}
		},
		parent: {
			type: Object, 
			default: () => {return {}}
		}
	},
  setup(__props) {

	const props = __props

	const {t} = useI18n()

	const instructionList = ref()
	const loading = ref(false)

	onMounted(async () => {
		try { // getting instructions
			loading.value = true
			const recordId = props.data.recordId

			const scriptParams = JSON.stringify({
				language: _localesStore.getFmLanguage,
			})

			const params = `?script.prerequest=${encodeURI("Set Language")}&script.prerequest.param=${encodeURI(scriptParams)}`
			let res = await getSceneOptionsRolesInstructionsByRecordId(recordId, params)
			const record = res.response.data[0]
						
			instructionList.value = record.portalData.jobs_scenes_options_roles__INSTRUCTIONS_JOIN_JOBS_jobsScenesOptionsRolesID
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false
		}
	})

	const _localesStore = localesStore()
	
	
	function hasPicture(row: any) {
		return row?.['jobs_scenes_options_roles__INSTRUCTIONS_JOIN_JOBS_jobsScenesOptionsRolesID::s3JSONPicture']
	}

	function hasVideo(row: any) {
		return row?.['jobs_scenes_options_roles__INSTRUCTIONS_JOIN_JOBS_jobsScenesOptionsRolesID::s3JSONVideo']
	}

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.showDetails(__props.parent, 'optionsTabs', 1, null))),
        class: "flex justify-start items-center cursor-pointer"
      }, [
        _createVNode(_component_ArrowLeftIcon, { class: "w-5 h-5" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.returnToRoles")), 1)
        ])
      ])
    ]),
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noInstructions'),
      data: instructionList.value,
      loading: loading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('149'),
          prop: "jobs_scenes_options_roles__instructions_join_jobs__INSTRUCTIONS__instructionID::name_display"
        }, null, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('181'),
          prop: "jobs_scenes_options_roles__INSTRUCTIONS_JOIN_JOBS_jobsScenesOptionsRolesID::instructions_display_edit"
        }, null, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          "class-name": "w-6",
          "header-class-name": "w-6",
          "align-text": "right"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", {
              class: "h-6 w-6 cursor-pointer",
              onClick: ($event: any) => (__props.showDetails(row, 'opRolesInstructions', null, __props.data))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass([hasPicture(row) ? 'linked-icon' : 'grayed-icon']),
                src: _imports_0,
                alt: "picture icon"
              }, null, 2)
            ], 8, _hoisted_3)
          ]),
          _: 1
        }),
        _createVNode(_component_tw_table_column, {
          "class-name": "w-6",
          "header-class-name": "w-6",
          "align-text": "right"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", {
              class: "h-6 w-6 cursor-pointer",
              onClick: ($event: any) => (__props.showDetails(row, 'opRolesInstructions', null, __props.data))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass([hasVideo(row) ? 'linked-icon' : 'grayed-icon']),
                src: _imports_1,
                alt: "picture icon"
              }, null, 2)
            ], 8, _hoisted_4)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"])
  ], 64))
}
}

})